import { render, staticRenderFns } from "./_postControls.vue?vue&type=template&id=4daa8b24"
import script from "./_postControls.vue?vue&type=script&lang=js"
export * from "./_postControls.vue?vue&type=script&lang=js"
import style0 from "./_postControls.vue?vue&type=style&index=0&id=4daa8b24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports